import { ThemeConfig } from 'antd';

/**
 * Ant Design 5.x/6.x 主题配置
 * 文档：https://ant.design/docs/react/customize-theme-cn
 */
export const antdThemeConfig: ThemeConfig = {
  token: {
    // 主色
    colorPrimary: '#00C8C8',
    
    // 其他颜色
    // colorSuccess: '#52c41a',
    // colorWarning: '#faad14',
    // colorError: '#f5222d',
    // colorInfo: '#1890ff',
    
    // 字体
    // fontSize: 14,
    fontFamily: 'PingFang SC, Microsoft YaHei, sans-serif, PingFangSC-Regular, Droid Sans Fallback, Arial, Helvetica',
    fontWeightStrong: 500,
    
    // // 圆角
    // borderRadius: 6,
    
    // 间距
    // paddingLG: 24,
    // paddingMD: 16,
    // paddingSM: 12,
  },
  
  // 组件级别的样式定制
  components: {
    Button: {
      // 按钮组件定制
      primaryShadow: 'none',


    },
    Input: {
      // 输入框组件定制
      // controlHeight: 32,
      // borderRadius: 6,
      fontSize: 16,
      hoverBorderColor: '#24B5E5',
      activeBorderColor: '#24B5E5',
    },
    Tooltip: {
      // Tooltip 组件定制
      borderRadius: 18,
      colorBgSpotlight: 'rgba(255,255,255,1)',
      colorTextLightSolid: 'rgba(0,3,17,1)',
    },
    Modal: {
        titleFontSize: 16,
        titleColor: '#272933',
        titleLineHeight: 1,
    },
    // 可以继续添加其他组件的定制
  },
};
